import React from 'react';
import Form from 'react-bootstrap/Form';
import RichText from '../controls/RichText';
import Dropdown from 'react-bootstrap/Dropdown';
import TaskSlider from '@bittnerdevelopmentgroup/interactive/dist/TaskSlider/TaskSlider';
import { useForceUpdate, getRawText, isValidURL } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
export default function Image(props) {
  var _dataProps$style, _dataProps$style2, _floatLabels$dataProp, _dataProps$style3;
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const floatLabels = {
    none: "Centered",
    left: "Float Left",
    right: "Float Right"
  };
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Image Information"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.src,
    onChange: e => {
      dataProps.src = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.src)
  }, "Please type in a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.alt,
    onChange: e => {
      dataProps.alt = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.alt.length > 0
  }, "Images must have alt text.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Long Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A longer description of the image (optional).")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.longAlt,
    onChange: v => {
      dataProps.longAlt = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Width:"), " ", /*#__PURE__*/React.createElement("i", null, "The maximum width of the image, as a percentage.")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.style = dataProps.style || {};
      dataProps.style.width = `${value}%`;
      forceUpdate();
      props.onChanged();
    },
    start: ((_dataProps$style = dataProps.style) === null || _dataProps$style === void 0 ? void 0 : _dataProps$style.width) === undefined ? 100 : parseInt((_dataProps$style2 = dataProps.style) === null || _dataProps$style2 === void 0 ? void 0 : _dataProps$style2.width),
    min: 25,
    max: 100,
    step: 1,
    tooltip: "auto"
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alignment:"), " ", /*#__PURE__*/React.createElement("i", null, "A longer description of the image (optional).")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, (_floatLabels$dataProp = floatLabels[(_dataProps$style3 = dataProps.style) === null || _dataProps$style3 === void 0 ? void 0 : _dataProps$style3.float]) !== null && _floatLabels$dataProp !== void 0 ? _floatLabels$dataProp : "None"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.float = "none";
      dataProps.style.marginLeft = "auto";
      dataProps.style.marginRight = "auto";
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "None"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.float = "left";
      dataProps.style.marginRight = "1em";
      dataProps.style.marginLeft = 0;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "Float Left"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.float = "right";
      dataProps.style.marginLeft = "1em";
      dataProps.style.marginRight = 0;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "Float Right")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Credit")), /*#__PURE__*/React.createElement(RichText, {
    noWapper: true,
    value: dataProps.photoCredit,
    onChange: v => {
      dataProps.photoCredit = v;
      forceUpdate();
      props.onChanged();
    }
  })))));
}